// extracted by mini-css-extract-plugin
module.exports = {"detail":"styles_detail__2G-Mo","time":"styles_time__2k5k3"};